import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import WeddingPage from "@/pages/WeddingPage";
import AdminPage from "@/pages/AdminPage";
import EntouragePage from "@/pages/EntouragePage";
import MoodboardPage from "@/pages/MoodboardPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WeddingPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/entourage" element={<EntouragePage />} />
          <Route path="/photo" element={<MoodboardPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#FAF7F2",
            color: "#2C1A1D",
            border: "1px solid #E2D3C1",
            fontFamily: "Jost, sans-serif",
            letterSpacing: "0.04em",
          },
        }}
      />
    </div>
  );
}

export default App;
